import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { DARK_BUTTON_BACKGROUND, DARK_IMAGE_CONTAINER, PRIMARY_BUTTON } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      '& .MuiOutlinedInput-root': {
        height: '50px!important',
        fontSize: 14,
      },
      '& .MuiFormLabel-root': {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '13px',
        letterSpacing: '1px',
        alignItems: 'center',
        '& .MuiBox-root': {
          padding: '2px 4px 1px 5px',
          border: '1px solid',
          borderRadius: '100%',
          fontSize: '12px',
        },
      },
      '& .MuiSelect-iconOutlined': {
        right: '0',
        top: '22px',
      },
      '& .MuiSelect-iconOpen': {
        top: '2px',
        right: '13px',
      },
      marginBottom: 20,
    },
    header: {
      marginBottom: 20,
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 320,
      alignSelf: 'center',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: 15,
      alignItems: 'center',
    },
    imgContainer: {
      background: DARK_IMAGE_CONTAINER,
      height: 400,
      borderRadius: 5,
      width: 283,
      position: 'relative',
    },
    btn: {
      height: 44,
      maxWidth: 283,
      width: '100%',
      marginTop: 20,
      border: `1px solid ${PRIMARY_BUTTON}`,
      background: DARK_BUTTON_BACKGROUND,
      borderRadius: 8,
    },

    img: {
      height: 400,
      borderRadius: 5,
      width: 283,
      objectFit: 'cover',
    },

    tooltipContainer: {
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down(960)]: {
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 15,
      },

      marginTop: 85,
      '& .MuiSvgIcon-root': {
        fontSize: 20,
        marginRight: 10,
        marginBottom: -2,
      },
    },
  }),
);
